import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";

import DataTable from "components/DataTable/DataTable";
import Layout from "components/Layout/Layout";
import LoginCallback from "components/LoginCallback/LoginCallback";
import NoLocationSelected from "components/NoLocationSelected/NoLocationSelected";
import NoPartnerSelected from "components/NoPartnerSelected/NoPartnerSelected";
import { memo } from "react";
import { wrapCreateBrowserRouter } from "@sentry/react";

function AppRoutes() {
  const MemoizedDataTable = memo(DataTable);

  const router = sentryCreateBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/login/callback" element={<LoginCallback />} />
        <Route path="/" element={<Layout />}>
          <Route index path="/" element={<NoPartnerSelected />} />
          <Route path=":partnerId">
            <Route index element={<NoLocationSelected />} />
            <Route path=":posGUID" element={<MemoizedDataTable />} />
          </Route>
        </Route>
      </>
    )
  );

  return <RouterProvider router={router} />;
}

export default AppRoutes;

const sentryCreateBrowserRouter = wrapCreateBrowserRouter(createBrowserRouter);
